import createGetEnumerationsSelector from './createGetEnumerationsSelector';
import { getFunctionSensors } from '../getFunctionSensors';

export const getFunctionEnumerations = createGetEnumerationsSelector(getFunctionSensors);